const getPasswordError = pwd => {
  if (typeof pwd === 'undefined') {
    return 'Password is required';
  }
  if (pwd.length < 8) {
    return 'Password must contain min 8 chars';
  } else if (pwd.length > 50) {
    return 'Password too long';
  } else if (pwd.search(/\d/) === -1) {
    return 'Password must contain a number';
  } else if (pwd.search(/[A-Z]/) === -1) {
    return 'Password must contain a capital letter';
  } else if (pwd.search(/[a-z]/) === -1) {
    return 'Password must contain a lower case letter';
  }
  return '';
};

export default getPasswordError;
